import React from 'react'
import styled from 'react-emotion'

const Container = styled.div``

const Premium = () => <Container>Premium</Container>

export default Premium
